module.exports = __webpack_public_path__ + "img/drop.db756dd5.png";